import { createFeature, createReducer } from '@ngrx/store';

import { jobInventoryReducers } from './job-inventory.reducer';
import { jobInventoryInitialState } from './job-inventory.state';

export const jobInventoryFeature = createFeature({
  name: 'jobV3Inventory',
  reducer: createReducer(jobInventoryInitialState, ...jobInventoryReducers),
});
